/**
 * Change Outfit screen (change_outfit tool): the shared style-template screen
 * with the keep-pose switch. See ./styleTool.ts.
 */
import { renderStyleTool } from './styleTool.js';
import { outfitOptions } from './toolOptions.js';

export function renderChangeOutfit(root: HTMLElement, query: URLSearchParams): void {
  renderStyleTool(root, query, {
    tool: 'change_outfit',
    title: 'Change Outfit',
    subtitle: 'Try on different styles and transform your look with AI.',
    stylesTitle: 'Choose a style',
    seeAllHref: '#/category/change-outfit',
    cta: 'Generate Outfit',
    emptyIcon: 'checkroom',
    emptyText: 'No outfit styles are available yet. Please check back soon.',
    makeOptions: outfitOptions,
  });
}
